import { useMutation, useQuery } from '@tanstack/react-query';

import { Endpoints, OrganizationConfig } from '@/api';
import { useFetch } from '@/utils/fetch';

export type Organization = {
  id: string;
  name: string;
  nameAlias: string | null;
  slug: string;
  slugAlias: string | null;
  config: OrganizationConfig;
};

export const useOrganization = (slug?: string) => {
  const fetch = useFetch<Endpoints['GET /organizations/:slug']>();

  return useQuery({
    queryKey: ['organizations', slug],
    queryFn: () => fetch(`/organizations/${slug!}`),
    enabled: !!slug,
  });
};

export const useOrganizationWorkflows = (slug?: string) => {
  const fetch = useFetch<Endpoints['GET /organizations/:slug/workflows']>();

  return useQuery({
    queryKey: ['organizations', slug, 'workflows'],
    queryFn: () => fetch(`/organizations/${slug!}/workflows`),
    enabled: !!slug,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnMount: false,
  });
};

export type CustomFieldsType = Record<string, string>;

export const useCreateOrganization = () => {
  const fetch = useFetch<Endpoints['POST /organizations']>();

  return useMutation<
    Endpoints['POST /organizations']['response'],
    Error,
    Endpoints['POST /organizations']['body']
  >({
    mutationFn: (body) => fetch('/organizations', undefined, { method: 'POST', body }),
  });
};
